import ResendCertificationLetterModal from './ResendCertificationLetterModal';

export default ResendCertificationLetterModal;
